import { render } from "./BlockStory.vue?vue&type=template&id=283b3dcc"
import script from "./BlockStory.vue?vue&type=script&lang=js"
export * from "./BlockStory.vue?vue&type=script&lang=js"

import "./BlockStory.vue?vue&type=style&index=0&id=283b3dcc&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__